/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventoryFilterRequestDataModel {
    getFixupPrototypeFunction() { return InventoryFilterRequestDataModel.fixupPrototype; }

    static newInstance(model: Partial<InventoryFilterRequestDataModel>): InventoryFilterRequestDataModel {
        let obj = Object.assign(new InventoryFilterRequestDataModel(), model);
        InventoryFilterRequestDataModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventoryFilterRequestDataModel>): InventoryFilterRequestDataModel {
        if (!model) return null;
        return InventoryFilterRequestDataModel.newInstance(<InventoryFilterRequestDataModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventoryFilterRequestDataModel) {
        if (!obj) return;

        models.InventoryFilterRequestDataModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventoryFilterRequestDataModel): boolean {
        Object.setPrototypeOf(obj, InventoryFilterRequestDataModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the cloud account
     */
    name: string;

    /**
     * ID of the cloud account
     */
    id: string;

    /**
     * Preferred region of AWS account
     */
    preferred_regions: Array<string>;

}
